<template>
  <ul class="borrower-list">
    <li v-for="(borrower, index) in borrowerList" :key="'borrower_' + index">
      <div v-if="icon">
        <img class="borrower-photo" :src="icon" />
      </div>
      <div class="borrower-photo" v-else>
        <icon :icon="['fad', 'user-circle']" />
      </div>
      <div class="borrower-id">
        <a href="#" @click.prevent v-if="listtype == 1">{{ borrower.FirstName.value }} {{ borrower.LastName.value }}</a>
        <div class="sub small" v-html="description" v-if="description"></div>
      </div>
      <template v-if="borrower.fillingOnBehalf.value == 'yes' || index == $store.state.borrower_index || index == 0">
        <div class="borrower-button">
          <template v-if="$store.getters.isPageComplete(targetid, borrower.Id)">
            <button type="button" class="btn-default" @click="onStart($event, index)">
              Edit
            </button>
            <button type="button" class="btn-primary-outline" title="Completed">
              <icon :icon="['far', 'check-circle']" />
            </button>
          </template>
          <button type="button" class="btn-primary" @click="onStart($event, index)" v-else>
            Start
          </button>
        </div>
      </template>
      <template v-else>
        <div class="borrower-button">
          <button type="button" class="btn-default btn-locked icon-left">
            <icon :icon="['fas', 'lock']" /> Locked
          </button>
        </div>
      </template>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'BorrowerList',
  components: {},
  props: {
    targetid: String,
    description: String,
    listtype: Number,
    icon: String
  },
  computed: {
    borrowerList: function () {
      var list = this.$store.state.borrowers

      if (this.listtype == 2 && list.length > 1)
        list = list.slice(0, 1)

      return list
    }
  },
  methods: {
    onStart: function(evt, index) {
      // Set borrower
      const prevBorrowerID = this.$store.state.borrowerid
      this.$store.commit('becomeBorrower', index)
      const newBorrowerID = this.$store.state.borrowerid
      if (prevBorrowerID !== newBorrowerID) this.$root.$emit('borrower:change')

      // Set current page
      //this.$store.commit('setPage', this.targetid)
      this.$store.dispatch('navGo', this.targetid)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/_variables.scss';

ul.borrower-list {
  list-style: none;
  padding: 0;
  li {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;
    .borrower-photo {
      width: 28px;
      height: 28px;
      border-radius: 50%;
      //background: $lighter-gray;
      .svg-inline--fa {
        font-size: 28px;
      }
    }
    .borrower-id {
      padding-left: 1rem;
      a {
        display: block;
        width: 100%;
      }
      .sub {
        padding-top: 0.2rem;
      }
    }
    .borrower-button {
      flex: 1;
      text-align: right;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }

    .svg-icon {
      width: 28px;
    }

    .btn-primary-outline {
      margin-left: 10px;
    }
  }
}
</style>
